import { Capability } from '@infuse/api/cpms/config';
import { Connector } from '@infuse/cpms/config/store';

// Represents an Evse with exactly one Connector, in one.
export interface FlatConnector extends Connector {
  evseIdentifier: number;
  evseCapabilities?: Capability[];
}

export const flatConnectorDefaults = {
  evseIdentifier: 1,
  evseCapabilities: [],
  phases: null,
  current: null,
  connectorType: null,
  maxElectricPower: 0
};
